import React, { useState, useRef, useEffect } from "react";
import { EyeIcon, EyeOffIcon, XIcon } from "lucide-react";
import axios from "axios"; // Ensure axios is imported
import { BASE_URL, API_TOKEN, SLINK } from "../../config";

// Define SLINK

const LoginPage = ({ onClose, onSwitch }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(""); // New state for email
  const [password, setPassword] = useState(""); // New state for password
  const [errorMessage, setErrorMessage] = useState(""); // New state for error messages

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent default form submission
    try {
      const response = await axios.post(
        `${BASE_URL}/customer/login?slink=${SLINK}`,
        { email, password }
      );
      console.log("koushiikssignup", response.data);

      if (response.data) {
        localStorage.setItem("auth-token", response.data.accessToken);
        localStorage.setItem("device_id", response.data.uuid);
        localStorage.setItem("username", response.data.user_name);
        onClose(); // Close the popup on successful login
        window.location.replace("/"); // Redirect to the home page
      } else {
        setErrorMessage("Login failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Invalid email or password. Please try again.");
      console.error("Login error:", error);
    }
  };

  return (
    <div className="bg-[#1c1c1c] p-8 rounded-lg w-full max-w-md relative">
      <button
        className="absolute top-4 right-4 text-gray-400 hover:text-white"
        onClick={onClose} // Close the popup
      >
        <XIcon size={24} />
      </button>
      <h1 className="text-[#ffd700] text-3xl font-bold text-center mb-2">
        Login
      </h1>
      <p className="text-white text-center mb-8">
        Welcome back, we missed you!
      </p>
      <form className="space-y-6" onSubmit={handleLogin}>
        <div>
          <input
            type="email"
            placeholder="E-mail *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={email} // Bind email state
            onChange={(e) => setEmail(e.target.value)} // Handle email change
          />
        </div>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={password} // Bind password state
            onChange={(e) => setPassword(e.target.value)} // Handle password change
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
          </button>
        </div>
        {errorMessage && (
          <p className="text-red-500 text-center">{errorMessage}</p>
        )}{" "}
        {/* Display error message */}
        <button
          type="submit"
          className="w-full bg-[#ffd700] text-black font-bold py-3 rounded-lg hover:bg-[#e5c100] transition duration-300"
        >
          Login
        </button>
      </form>
      <p className="text-gray-400 text-center mt-6">
        Don't have an account?{" "}
        <button onClick={onSwitch} className="text-[#ffd700] hover:underline">
          Create an account now
        </button>
      </p>
    </div>
  );
};

const RegisterPage = ({ onClose, onSwitch }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(""); // New state for phone number
  const [username, setUsername] = useState(""); // New state for username
  const [email, setEmail] = useState(""); // New state for email
  const [password, setPassword] = useState(""); // New state for password
  const [cpassword, setCPassword] = useState(""); // New state for confirm password
  const [errorMessage, setErrorMessage] = useState(""); // New state for error messages

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== cpassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/customer/register?slink=${SLINK}`,
        { name: username, email, mobile: phoneNumber, password, cpassword }
      );
      console.log("leksmana", response.data);
      if (response.data || response.data.authToken) {
        localStorage.setItem("auth-token", response.data.authToken);
        onClose(); // Close the popup on successful registration
        window.location.replace("/"); // Redirect to the home page
      } else {
        setErrorMessage("Registration failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Registration error. Please try again.");
      console.error("Registration error:", error);
    }
  };

  return (
    <div className="bg-[#1c1c1c] p-8 rounded-lg w-full max-w-md relative">
      <button
        className="absolute top-4 right-4 text-gray-400 hover:text-white"
        onClick={onClose} // Close the popup
      >
        <XIcon size={24} />
      </button>
      <h1 className="text-[#ffd700] text-3xl font-bold text-center mb-2">
        Register
      </h1>
      <p className="text-white text-center mb-8">Create a new account!</p>
      <form className="space-y-6" onSubmit={handleRegister}>
        <div>
          <input
            type="text"
            placeholder="Username *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={username} // Bind username state
            onChange={(e) => setUsername(e.target.value)} // Handle username change
          />
        </div>
        <div>
          <input
            type="email"
            placeholder="E-mail *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={email} // Bind email state
            onChange={(e) => setEmail(e.target.value)} // Handle email change
          />
        </div>
        <div>
          <input
            type="tel" // Changed to tel for phone number input
            placeholder="Phone Number *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)} // Handle phone number change
            required
          />
        </div>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={password} // Bind password state
            onChange={(e) => setPassword(e.target.value)} // Handle password change
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOffIcon size={20} /> : <EyeIcon size={20} />}
          </button>
        </div>
        <div className="relative">
          <input
            type={showConfirmPassword ? "text" : "password"} // New input for confirm password
            placeholder="Confirm Password *"
            className="w-full bg-[#2a2a2a] text-white placeholder-gray-400 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-[#ffd700]"
            required
            value={cpassword} // Bind confirm password state
            onChange={(e) => setCPassword(e.target.value)} // Handle confirm password change
          />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle confirm password visibility
          >
            {showConfirmPassword ? (
              <EyeOffIcon size={20} />
            ) : (
              <EyeIcon size={20} />
            )}
          </button>
        </div>
        {errorMessage && (
          <p className="text-red-500 text-center">{errorMessage}</p>
        )}{" "}
        {/* Display error message */}
        <button
          type="submit"
          className="w-full bg-[#ffd700] text-black font-bold py-3 rounded-lg hover:bg-[#e5c100] transition duration-300"
        >
          Register
        </button>
      </form>
      <p className="text-gray-400 text-center mt-6">
        Already have an account?{" "}
        <button onClick={onSwitch} className="text-[#ffd700] hover:underline">
          Login now
        </button>
      </p>
    </div>
  );
};

export default function AuthPage({ onClose }) {
  const [isLogin, setIsLogin] = useState(true);
  const authRef = useRef(null); // Create a ref for the auth page

  const togglePage = () => {
    setIsLogin(!isLogin);
  };

  // Close the popup when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (authRef.current && !authRef.current.contains(event.target)) {
        onClose(); // Close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={authRef} className="relative">
      {isLogin ? (
        <LoginPage onClose={onClose} onSwitch={togglePage} />
      ) : (
        <RegisterPage onClose={onClose} onSwitch={togglePage} />
      )}
    </div>
  );
}
